"use client";

import { useState } from "react";
import { MenuIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { NavLink } from "./nav-link";
import { navigation } from "./links";
import {
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from "@/components/ui/drawer";

export function MobileMenu({
  showShop,
  ariaLabel,
}: {
  showShop?: boolean;
  ariaLabel?: string;
}) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Drawer open={isOpen} onOpenChange={setIsOpen}>
      <DrawerTrigger asChild>
        <Button
          variant="subtle"
          left={<MenuIcon className="h-5 w-5" />}
          className="lg:hidden"
          aria-label={ariaLabel}
        >
          Menü
        </Button>
      </DrawerTrigger>
      <DrawerContent className="mx-auto w-full max-w-md">
        <DrawerHeader>
          <DrawerTitle>Menü</DrawerTitle>
        </DrawerHeader>
        <div className="mt-auto flex max-h-[80vh] w-full flex-col gap-0 overflow-auto p-4 text-left">
          {navigation.map((item) => (
            <NavLink variant="disclosure" key={item.title} {...item} openSheet={isOpen} setOpenSheet={setIsOpen} />
          ))}
        </div>
      </DrawerContent>
    </Drawer>
  );
}
